/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTargetListItemData
 */
export interface OutputTargetListItemData {
    /**
     * 
     * @type {boolean}
     * @memberof OutputTargetListItemData
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetListItemData
     */
    coords?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetListItemData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetListItemData
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetListItemData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetListItemData
     */
    targetType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetListItemData
     */
    zone?: string;
}

/**
 * Check if a given object implements the OutputTargetListItemData interface.
 */
export function instanceOfOutputTargetListItemData(value: object): boolean {
    return true;
}

export function OutputTargetListItemDataFromJSON(json: any): OutputTargetListItemData {
    return OutputTargetListItemDataFromJSONTyped(json, false);
}

export function OutputTargetListItemDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTargetListItemData {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'coords': json['coords'] == null ? undefined : json['coords'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'] == null ? undefined : json['id'],
        'targetType': json['target_type'] == null ? undefined : json['target_type'],
        'zone': json['zone'] == null ? undefined : json['zone'],
    };
}

export function OutputTargetListItemDataToJSON(value?: OutputTargetListItemData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'active': value['active'],
        'coords': value['coords'],
        'created_at': value['createdAt'],
        'description': value['description'],
        'id': value['id'],
        'target_type': value['targetType'],
        'zone': value['zone'],
    };
}

